import styled, { css } from 'styled-components';
import { colorCSS, fontSizes, generateFieldsStyles, shadow } from '../../styles';
const cardCSS = css `
  background-color: ${colorCSS('N0')};
  box-shadow: ${shadow.normal};
  color: ${colorCSS('N800')} !important;
  display: block;
  min-height: 100%;
  overflow: hidden;
  padding: 8rem 1rem 1.5rem;
  position: relative;
  text-align: left;
  p {
    margin: 0.75rem auto 0;
    font-size: ${fontSizes.sm};
    min-height: 4.5rem;
  }
  &:before {
    ${({ decoration }) => decoration
    ? generateFieldsStyles(decoration)
    : `background-color: ${colorCSS('N100')};`};
    content: '';
    display: block;
    height: 6.2rem;
    left: 0;
    position: absolute;
    right: 0;
    top: 0;
  }
`;
export const Card = styled.article `
  ${cardCSS}
  p {
    margin-bottom: 2.5rem;
  }
  a {
    position: absolute;
    bottom: 1rem;
    left: 1rem;
    ${({ appearance }) => !appearance &&
    `
      color: inherit !important;
      font-size: ${fontSizes.sm};
      text-decoration: underline;
      text-underline-offset: 0.3rem;
      padding: 0 0 .5rem;
      `};
  }
`;
export const CardLink = styled.a `
  ${cardCSS}
  text-decoration: none;
  h3 {
    text-decoration: underline;
    text-underline-offset: 0.3rem;
  }
`;
//# sourceMappingURL=UiCard.styles.js.map